
// Can pull the old game list from my code, or from BoardGameGeek
var GameList = [
  {
    gameId: 0,
    name: "Settlers of Catan",
    logo: "settlers.png",
    ucp: null,
    bggLink: null,  // link to docs/commentary or just game?
  },
  {
    gameId: 1,
    name: "Uno",
    logo: "uno.jpeg",
  },
  {
    gameId: 2,
    name: "Qwirkle",
    logo: "qwirkle.jpeg"
  },
  {
    gameId: 3,
    name: "Mr. Jack",
    logo: "http://timphilip.net/thumbnails/21763.jpg",
  },
  {
    gameId: 4,
    name: "Kingdom Builder",
    logo: null,
  },
  {
    gameId: 5,
    name: "Uptown",
    logo: null,
  },
  {
    // I think I should handle expansions differently ...
    // Maybe also "families"?
    gameId: 6,
    name: "Kingdom Builder - Crossroads Expansion",
    logo: null,
  },
  {
    gameId: 7,
    name: "Roll for the Galaxy",
    logo: null,
  },
  {
    gameId: 8,
    name: "Uptown",
    logo: null,
  },
  {
    gameId: 9,
    name: "Puzzle Strike",
    logo: "http://timphilip.net/thumbnails/67928.jpg",
  },
  {
    gameId: 10,
    name: "Dominion",
    logo: null,
  },
  {
    gameId: 11,
    name: "Five Tribes",
    logo: null,
  },
  {
    gameId: 12,
    name: "Carcassonne",
    logo: "http://timphilip.net/thumbnails/822.jpg",
  },
];

export default GameList;



// WEBPACK FOOTER //
// ./src/data/GameList.js